import { RigFracChartWidgetKey } from "components/dashboard/constants/widgets.constants";

import { useChartWidgetSession } from "./useChartWidgetSession";

/**
 * Session key prefix. Imported from WidgetKeys rather than restated as a literal
 * so the "must equal the widget's type" invariant is structural — the dashboard
 * reads this key by that exact string, and a mismatch persists nothing at all,
 * silently.
 */
export const RIG_FRAC_SESSION_KEY_PREFIX = RigFracChartWidgetKey;

/**
 * The user's SELECTIONS — never the transient map viewport bbox (re-derived live
 * by the controller) or the static defaults.
 */
const PERSISTED_REQUEST_KEYS = [
  "chartType",
  "primaryMetric",
  "secondaryMetric",
  // EVA-76 wire names, superseded by primaryMetric/secondaryMetric (EVA-149).
  // Kept for a deprecation window so a dashboard saved by an old client and
  // read by a new one (or vice versa) both still restore their selection.
  "leftMetric",
  "rightMetric",
  "metric",
  "groupBy",
  "timeScale",
  "customRange",
  "colorPalette",
  "maxBins"
] as const;

/**
 * Persists the rig/frac widget's config for the dashboard save round-trip.
 *
 * Thin wrapper over {@link useChartWidgetSession}; the two widgets that use it
 * differ only in their key and their persisted request fields. See that hook for
 * why the write half matters and what is deliberately left out.
 */
export function useRigFracSession(id: string) {
  useChartWidgetSession(id, RIG_FRAC_SESSION_KEY_PREFIX, PERSISTED_REQUEST_KEYS);
}
